// Patch 28 · a tiny vibration on Android when you vote or tap Pixie (iPhone browsers ignore it).
export function buzz(ms = 15) {
  try {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    if (navigator.vibrate) navigator.vibrate(ms);
  } catch {
    /* not supported */
  }
}
